import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import Icon from '../../../../components/ui/Icon/Icon'
import ToggleSwitch from '../../../../components/ui/ToggleSwitch/ToggleSwitch'

import RightSideBarHeader from '../../../../assets/img/right-sidebar-header.svg'
import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'

import {
  MAIN,
  MANAGE_PREFERENCES,
  // CHANGE_PASSWORD,
} from '../../../../services/data/profilePages.json'
import SettingsModal from '../../../../components/home/SettingsModal/SettingsModal'

const MainPage = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
`

const Header = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  min-height: 87px;
  font-size: 0.7rem;
  z-index: 100;

  ${props =>
    props.hasScrolled &&
    css`
    background: url('${MoreHeaderParticles}'), linear-gradient(var(--color-primary), var(--color-primary));
    background-repeat: no-repeat;
    background-position: right top;
  `}
`

const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

const PageBody = styled.div`
  &::before {
    content: ' ';
    display: block;
    height: 197px;
    background-color: var(--color-primary);
    background: url('${RightSideBarHeader}'), url('${MoreHeaderParticles}'), linear-gradient(var(--color-primary), var(--color-primary));
    background-position: bottom, right top;
    background-repeat: no-repeat;
    background-size: 100%, auto;
  }
`

const ProfileNav = styled.ul`
  position: relative;
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 1.5rem;
  padding: 0 1.1875rem;
`

const NavItem = styled.li`
  color: var(--color-primary);
  cursor: pointer;
  list-style: none;
  padding: 1rem 0;
  border-top: 1px solid var(--color-fg-lighter);
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;

  cursor: pointer;

  svg {
    color: var(--color-primary);
  }
`

const ItemName = styled.span`
  flex-grow: 1;
  padding-left: 5px;
  font-size: 0.875rem;
  color: var(--color-primary);

  &:hover {
    color: var(--color-primary-hover);
  }
`

class SettingsPage extends React.Component {
  state = {
    scrollPosition: 0,
    hasScrolled: false,
    userSettings: null,
    disableButtons: false,
    displaySettingsModal: false,
  }

  currentPage = React.createRef()

  toggleSettingsModal = () => {
    const { displaySettingsModal } = this.state
    this.setState({ displaySettingsModal: !displaySettingsModal })
  }

  toggleAnnouncementSwitch = () => {
    const { receiveAnnouncement } = this.state.userSettings || {}
    if (receiveAnnouncement) this.toggleSettingsModal()
    else this.onAnnouncementAgree()
  }

  setUserSettings = userSettings => {
    this.setState({ userSettings })
  }

  setReceiveAnnouncements = value => {
    this.setState({
      userSettings: {
        receiveAnnouncement: value,
      },
    })
  }

  setDisable = value => {
    this.setState({ disableButtons: value })
  }

  onAnnouncementAgree = () => {
    const { doSetUserSettings, accessToken } = this.props
    const { userSettings, displaySettingsModal } = this.state
    const { receiveAnnouncement } = userSettings
    doSetUserSettings &&
      doSetUserSettings({
        accessToken,
        setUserSettings: this.setUserSettings,
        userSettings: {
          ...userSettings,
          receiveAnnouncement: !receiveAnnouncement,
        },
        setDisable: this.setDisable,
        toggleSettingsModal: this.toggleSettingsModal,
        displayModal: displaySettingsModal,
      })()
  }

  componentDidMount() {
    const { doGetUserSettings, accessToken } = this.props
    this.currentPage.current.addEventListener('scroll', this.handleScroll)
    doGetUserSettings &&
      doGetUserSettings({
        accessToken,
        setUserSettings: this.setUserSettings,
      })()
  }

  componentWillUnmount() {
    this.currentPage.current.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = event => {
    const { hasScrolled: hasScrolledState } = this.state
    const { scrollTop } = event.target
    const hasScrolled = scrollTop > 0

    if (hasScrolled !== hasScrolledState) {
      this.setState({
        hasScrolled,
      })
    }
  }

  render() {
    const { hasScrolled, userSettings, displaySettingsModal } = this.state
    const {
      // primaryInfo,
      setProfileModalPage,
      accessToken,
    } = this.props
    // const { facebookId = null, googleId = null, appleId = null } =
    //   primaryInfo || {}
    const { receiveAnnouncement } = userSettings || {}
    return (
      <MainPage ref={this.currentPage}>
        <Header hasScrolled={hasScrolled}>
          <ReturnIcon onClick={() => setProfileModalPage(MAIN)}>
            <Icon name="slide-left" />
          </ReturnIcon>
          <Title>Settings</Title>
        </Header>
        <PageBody small={!accessToken}>
          <ProfileNav>
            {/* {!(facebookId || googleId || appleId) && (
              <NavItem onClick={() => setProfileModalPage(CHANGE_PASSWORD)}>
                <ItemName>Change Password</ItemName>
                <Icon name="slide-right" />
              </NavItem>
            )} */}
            <NavItem onClick={() => setProfileModalPage(MANAGE_PREFERENCES)}>
              <ItemName>Manage Preferences</ItemName>
              <Icon name="slide-right" />
            </NavItem>
            <NavItem>
              <ItemName>Receive Zing Announcements</ItemName>
              <ToggleSwitch
                setDisable={this.setDisable}
                value={receiveAnnouncement}
                onChange={this.toggleAnnouncementSwitch}
                // onChange={this.toggleSettingsModal}
              />
            </NavItem>
          </ProfileNav>
        </PageBody>
        <SettingsModal
          zIndex={10025}
          show={displaySettingsModal}
          header={'Turn off announcements'}
          body={
            'By turning this off, you will not receive any email announcements from Zing. Would you like to proceed?'
          }
          onAgree={this.onAnnouncementAgree}
          onClose={this.toggleSettingsModal}
        />
      </MainPage>
    )
  }
}

SettingsPage.defaultProps = {}

SettingsPage.propTypes = {
  primaryInfo: PropTypes.object,
}

export default SettingsPage
